import React, { useEffect, useState } from "react";
import { report } from "../../../api/merchant";
import CheckSVG from "../../../assets/svg/CheckSVG";
import CancelSVG from "../../../assets/svg/CancelSVG";
import ReviewBorder from "../../../assets/svg/ReviewBorder";
import { clientEvents, reviewService } from "../../../api/client/listing";
import toast from "react-hot-toast";
const EventDetailsModal = ({ showIncomeDetails, onClose, handleRefresh }) => {
  const { status, code, serviceOffered, isRecommend } = showIncomeDetails;
  const [about, setAbout] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [bankAccount, setBankAccount] = useState(null);
  const [isRecommended, setIsRecommended] = useState(true);

  useEffect(() => {
    if (status && code) {
      handleInit();
    }
  }, [status, code]);

  const handleSubmit = async () => {
    const _requestData = {
      ribbon: isRecommended ? 1 : 0,
      booking_code: code,
      remarks: about,
      is_recommended: isRecommended ? 1 : 0,
    };
    const response = await reviewService(_requestData);
    if (response?.error === 0) {
      toast(response.msg);
      handleRefresh();
      onClose();
    } else {
      toast(response.error_msg);
    }
  };

  const handleInit = async () => {
    setIsLoading(true);
    try {
      const response = await clientEvents({
        flag: "view_transaction",
        booking_code: code,
      });

      if (response.error === 0) {
        setTransactionDetails(response.data.transaction_details || {});
      }
    } catch (err) {
      console.error("Error:", err);
    }
    setIsLoading(false);
  };

  const maskAccountNumber = (acc) => {
    return acc ? `${"*".repeat(acc.length - 4)}${acc.slice(-4)}` : "";
  };

  if (!status) return null;
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-xs">
      <div className="bg-white rounded-lg max-w-md w-full mx-4 p-4 relative overflow-y-auto max-h-[90vh]">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-black"
        >
          ✕
        </button>
        <div className="my-2">
          {isRecommend ? "Recommend" : "Event Details"}
        </div>

        {isLoading ? (
          <div className="space-y-4">
            <div className="animate-pulse space-y-2 text-center">
              <div className="h-6 bg-gray-200 w-1/3 mx-auto rounded"></div>
              <div className="h-5 bg-gray-200 w-1/2 mx-auto rounded"></div>
            </div>
            <div className="border border-gray-300 p-4 rounded-lg space-y-2">
              <div className="h-4 bg-gray-200 w-full rounded"></div>
              <div className="h-4 bg-gray-200 w-4/5 rounded"></div>
            </div>
            <div className="border border-gray-300 p-4 rounded-lg space-y-2">
              <div className="h-4 bg-gray-200 w-full rounded"></div>
              <div className="h-4 bg-gray-200 w-full rounded"></div>
              <div className="h-4 bg-gray-200 w-full rounded"></div>
              <div className="h-4 bg-gray-200 w-full rounded"></div>
              <div className="h-4 bg-gray-200 w-full rounded"></div>
              <div className="h-4 bg-gray-200 w-full rounded"></div>
              <div className="h-4 bg-gray-200 w-full rounded"></div>
              <div className="h-4 bg-gray-200 w-full rounded"></div>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            {/* Event Details */}
            {isRecommend && (
              <div className="overflow-hidden">
                {isMobile ? (
                  <></>
                ) : (
                  <div className="flex relative w-full">
                    <ReviewBorder height={180} />
                    <div className="absolute inset-14  flex space-x-4">
                      <img
                        src={serviceOffered?.cover_img || ""}
                        alt="Merchant Cover"
                        className="w-24 h-24 rounded-lg object-cover"
                      />
                      <div className="space-y-1">
                        <p className="font-semibold">{serviceOffered?.title}</p>
                        <div
                          className="text-xs py-1 px-2 text-center text-gray-500 rounded-full inline-block"
                          style={{
                            backgroundColor: "#E1E8FF",
                            width: "fit-content",
                          }}
                        >
                          {serviceOffered?.theme || "Any Event"}
                        </div>
                        <div className="flex gap-x-2 items-center flex-row">
                          <div className="w-5 h-5">
                            <div
                              className="icon-location h-full w-full "
                              style={{ backgroundPositionY: "center" }}
                            />
                          </div>
                          <p className="text-xs text-gray-400">
                            {serviceOffered.location}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="mt-4 space-y-2">
                  <p className="text-sm text-gray-600 mb-4">
                    Give a Gold Ribbon and recommend this merchant.
                  </p>
                  <div className="flex space-x-2">
                    <button
                      className={`flex items-center w-full px-3 py-2 border rounded-full ${
                        isRecommended
                          ? "bg-primary-500 text-white"
                          : "bg-white border-primary-500 text-primary-500"
                      }`}
                      onClick={() => setIsRecommended(true)}
                    >
                      {isRecommended ? <CheckSVG /> : <CancelSVG />}{" "}
                      <p className="pl-2">Yes</p>
                    </button>
                    <button
                      className={`flex items-center w-full px-3 py-2 border rounded-full ${
                        !isRecommended
                          ? "bg-primary-500 text-white"
                          : "bg-white border-primary-500 text-primary-500"
                      }`}
                      onClick={() => setIsRecommended(false)}
                    >
                      {!isRecommended ? <CheckSVG /> : <CancelSVG />}{" "}
                      <p className="pl-2">No</p>
                    </button>
                  </div>
                </div>

                {/* Remarks Section */}
                <div className="mt-4">
                  <p className="text-sm text-gray-400 mb-2">
                    Tell us, how did your event go with Anyaya Venue?
                  </p>
                  <textarea
                    rows={3}
                    autoFocus={true}
                    value={about}
                    onChange={(e) => setAbout(e.target.value)}
                    className="resize-none border rounded-xl w-full p-4 text-sm"
                  />
                </div>
              </div>
            )}

            {/* Income Breakdown */}
            <div className="border-t border-gray-300 p-4 space-y-2 bg-gray-50">
              <div className="flex justify-between text-sm text-gray-700">
                <span>Date</span>
                <span>{transactionDetails?.date}</span>
              </div>
              <div className="flex justify-between text-sm text-gray-700">
                <span>Booking Code</span>
                <span>{transactionDetails?.booking_code}</span>
              </div>
              <div className="flex justify-between text-sm text-gray-700">
                <span>
                  PHP {transactionDetails?.service_price} x{" "}
                  {transactionDetails?.days_count} day(s)
                </span>
                <span>PHP {transactionDetails?.contract_price}</span>
              </div>
              <div className="flex justify-between text-sm text-gray-700">
                <span>Service Fee</span>
                <span>PHP {transactionDetails?.service_fee}</span>
              </div>
              {transactionDetails?.surcharge_fee && (
                <div className="flex justify-between text-sm text-gray-700">
                  <span>Surcharge</span>
                  <span>PHP {transactionDetails?.surcharge_fee}</span>
                </div>
              )}
              <div className="flex justify-between font-semibold text-gray-800">
                <span>Total (PHP)</span>
                <span className="text-primary-500">
                  PHP {transactionDetails?.net_amount}
                </span>
              </div>
            </div>
            {isRecommend && (
              <div className="mx-4 mt-4 flex space-x-2">
                <button
                  className="flex-1 py-3 font-semibold text-sunrise-500 bg-white"
                  onClick={onClose}
                >
                  Do it later
                </button>
                <button
                  className="flex-1 py-3 rounded-xl bg-primary-500 text-white font-semibold hover:opacity-90"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EventDetailsModal;
